module.exports = __webpack_public_path__ + "music-608e5d0046a972570fbcca1c4aae759f.svg";